import React, { useEffect, useState } from "react";
import moment from "moment";

import DateTimePicker from "../DateTimePicker";
import "./style.scss";
import useTranslate from "../../../translate/useTranslate";

const RangeDatePicker = function ({ value, onChange }) {
  const { t } = useTranslate();
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  useEffect(() => {
    if (!value) {
      setStartDate("");
      setEndDate("");
    }
  }, [value]);

  useEffect(() => {
    onChange({ startDate, endDate });

    const _startDate = moment(new Date(startDate)).format("x");
    const _endDate = moment(new Date(endDate)).format("x");

    if (startDate && !endDate) {
      setEndDate(moment().format("YYYY-MM-DD"));
      return;
    }

    if (!startDate && endDate) {
      setStartDate(endDate);
      return;
    }

    if (_startDate > _endDate) {
      setEndDate(moment().format("YYYY-MM-DD"));
      return;
    }

    if (startDate && endDate) {
      onChange({ startDate, endDate });
    }
  }, [startDate, endDate]);

  const disabledFrom = (dt) => {
    const disable = moment(new Date(dt)).unix() > moment().unix();
    if (disable) {
      return true;
    } else {
      if (endDate) {
        // disable if date is older that endDate
        return moment(new Date(dt)).unix() > moment(new Date(endDate)).unix();
      } else {
        return false;
      }
    }
  };

  return (
    <div className="range-datepicker-wrapper">
      <DateTimePicker
        value={value ? value.startDate : ""}
        dateformat={"Y-m-d"}
        onChange={(_, dt) => setStartDate(dt)}
        placeholder={`${t("From")} ...`}
        options={{
          disable: [disabledFrom],
        }}
      />
      <DateTimePicker
        value={value ? value.endDate : ""}
        dateformat={"Y-m-d"}
        onChange={(_, dt) => setEndDate(dt)}
        placeholder="Iki..."
        options={{
          disable: [
            (dt) => {
              // disable if date is earlier that startDate
              if (startDate) {
                return (
                  moment(new Date(dt)).unix() <
                  moment(new Date(startDate)).unix()
                );
              } else {
                return false;
              }
            },
          ],
        }}
      />
    </div>
  );
};

export default RangeDatePicker;
